import React from "react";
import { PropertyEditorInteger } from "../PropertyEditorInteger";
import { StoryNode } from "../../StoryBook/StoryData";
import { Box } from "@mui/material";
import { PropertyEditorText } from "../PropertyEditorText";
import { PropertyEditorBoolean } from "../PropertyEditorBoolean";
import { PropertyEditorObjectList } from "../PropertyEditorObjectList";
import { IDesignValidationProvider, ValidationIssue } from "../../../rule-engine-core/Common/IDesignValidationProvider";

class Person {
    name?: string;
    age?: number;
    isMale?: boolean;

    constructor(name?: string, age?: number, isMale?: boolean) {
        this.name = name;
        this.age = age;
        this.isMale = isMale;
    }
}

const peopleList: Person[] = [new Person("carl", 30, true), new Person("jill", 40, false)];

const editObject = {
    people: peopleList,
};

const editObject2: { people: Person[] } & IDesignValidationProvider = {
    people: peopleList,

    getDesignValidationIssues(): ValidationIssue[] {
        return [new ValidationIssue("issue", "people"), new ValidationIssue("issue 2", "people")];
    },
};

export const ObjectListPropertyEditorStories = [
    new StoryNode(
        (logCallback) => {
            return (
                <PropertyEditorObjectList<Person>
                    sx={{ width: "300px" }}
                    editObject={editObject}
                    propertyName={"people"}
                    renderItemUI={(item) => {
                        return (
                            <Box
                                display={"flex"}
                                flexDirection={"column"}
                            >
                                <PropertyEditorText
                                    editObject={item}
                                    propertyName={"name"}
                                />
                                <PropertyEditorInteger
                                    editObject={item}
                                    propertyName={"age"}
                                />
                                <PropertyEditorBoolean
                                    editObject={item}
                                    propertyName={"isMale"}
                                />
                            </Box>
                        );
                    }}
                    getItemName={(item) => item.name ?? "Undefined"}
                    createNewItem={() => new Person()}
                    onChange={(v) => logCallback(v.map((p) => p.name).join(", "))}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Object List",
        "Default",
    ),

    new StoryNode(
        (logCallback) => {
            return (
                <PropertyEditorObjectList<Person>
                    sx={{ width: "300px" }}
                    editObject={editObject}
                    error={"Error Text"}
                    propertyName={"people"}
                    renderItemUI={(item) => {
                        return (
                            <Box
                                display={"flex"}
                                flexDirection={"column"}
                            >
                                <PropertyEditorText
                                    editObject={item}
                                    propertyName={"name"}
                                />
                                <PropertyEditorInteger
                                    editObject={item}
                                    propertyName={"age"}
                                />
                                <PropertyEditorBoolean
                                    editObject={item}
                                    propertyName={"isMale"}
                                />
                            </Box>
                        );
                    }}
                    getItemName={(item) => item.name ?? "Undefined"}
                    createNewItem={() => new Person()}
                    onChange={(v) => logCallback(v.map((p) => p.name).join(", "))}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Object List",
        "Error",
    ),
    new StoryNode(
        (logCallback) => {
            return (
                <PropertyEditorObjectList<Person>
                    sx={{ width: "300px" }}
                    editObject={editObject2}
                    propertyName={"people"}
                    renderItemUI={(item) => {
                        return (
                            <Box
                                display={"flex"}
                                flexDirection={"column"}
                            >
                                <PropertyEditorText
                                    editObject={item}
                                    propertyName={"name"}
                                />
                                <PropertyEditorInteger
                                    editObject={item}
                                    propertyName={"age"}
                                />
                                <PropertyEditorBoolean
                                    editObject={item}
                                    propertyName={"isMale"}
                                />
                            </Box>
                        );
                    }}
                    getItemName={(item) => item.name ?? "Undefined"}
                    createNewItem={() => new Person()}
                    onChange={(v) => logCallback(v.map((p) => p.name).join(", "))}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Object List",
        "Validation Provider",
    ),
];
